











import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import publicApi from '@/api/publicApi'
import * as OSS from 'ali-oss'
Vue.use(Viewer)
/**
 * 图片放大组件
 */
@Component
export default class ZoomImg extends Vue {
  @Prop() private imgData: any

  private accessKeyInfo: any = {}
  private client: any = {}
  private urlList: any[] = []
  public mounted() {
    this.changeImgList(this.imgData)
  }

  @Watch('imgData')
  protected changeUrl() {
    this.changeImgList(this.imgData)
  }

  protected changeImgList(url: any) {
    publicApi.getStsAccessKeyInfo({}).then((res) => {
      this.accessKeyInfo = res.data
      this.client = new OSS({
        accessKeyId: this.accessKeyInfo.accessKeyId || '',
        accessKeySecret: this.accessKeyInfo.accessKeySecret || '',
        stsToken: this.accessKeyInfo.securityToken || '',
        bucket: this.accessKeyInfo.bucketName || '',
        region: 'oss-cn-beijing'
      })
      url.forEach((v: any) => {
        const urlArr = this.client.signatureUrl(v)
        this.urlList.push(urlArr)
      });
    })
  }
}
